
import React from 'react';



function EditUserInfoRow({ type, label, value, id, onChange, status, required, readOnly}) {
  
  return (
    <div className="row mt-2">
      <div className="col-md-15"><label className="labels">{label}</label></div>
      <div className="col-md-14"><input type={type} className="form-control" id={id} name={id} value={value} onChange={onChange} required={required} readOnly={readOnly}  /></div>
      <div className="col-md-22"><label className="labels">{status}</label></div>
    </div>
  );
}

export default EditUserInfoRow;